"use strict";
/**
 * @module Services.Security
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var control_registration_params_1 = require("./../../services/control/control-registration-params");
/**
 * Data type for a AUTHENTICATOR_REGISTRATION request.
 */
var AuthenticatorRegistrationParameters = /** @class */ (function (_super) {
    __extends(AuthenticatorRegistrationParameters, _super);
    /**
     * Create a new AuthenticatorRegistrationParameters instance
     *
     * @param name        the name of the authenticator handler
     * @param definition  the service definition
     * @param group       the control group
     */
    function AuthenticatorRegistrationParameters(name, definition, group) {
        var _this = _super.call(this, definition, group) || this;
        _this.name = name;
        return _this;
    }
    return AuthenticatorRegistrationParameters;
}(control_registration_params_1.ControlRegistrationParams));
exports.AuthenticatorRegistrationParameters = AuthenticatorRegistrationParameters;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/authenticator-registration-parameters.js
// module id = 1998
// module chunks = 1